import { add } from "date-fns";
import React from "react";

import { HStack } from "@whoosh/design-system/src/components/primitive";

import { CalendarMonthProps } from "../types";
import { WeekDay } from "./WeekDay";

interface WeekRowProps extends CalendarMonthProps {
  startDateObj: Date;
}

export const WeekRow = (props: WeekRowProps) => {
  const { startDateObj } = props;

  const weekArray = Array(7).fill(0);
  return (
    <HStack mb={4} gap={2}>
      {weekArray.map((_, i) => {
        const curDateObj = add(startDateObj, { days: i });
        return <WeekDay key={`day-${i}`} curDateObj={curDateObj} {...props} />;
      })}
    </HStack>
  );
};
